import axios from 'axios';

const getHeaders = (token: string | undefined) => {
  return {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
};

export interface CompanySettings {
  CompanyName: string;
  ContactEmail: string;
  EmailFromAddress: string;
  EmailFromName: string;
  AccountingProviderType: string;
  ExactOnlineClientId: string;
  ExactOnlineCallbackUrl: string;
  HasExactOnlineConnection: boolean;
}

export interface UpdateCompanySettingsRequest {
  CompanyName?: string;
  ContactEmail?: string;
  EmailFromAddress?: string;
  EmailFromName?: string;
}

export interface ConfigureAccountingRequest {
  ProviderType: string;
  ExactOnlineClientId?: string;
  ExactOnlineClientSecret?: string;
  ExactOnlineCallbackUrl?: string;
}

export async function getCompanySettings(token: string | undefined): Promise<CompanySettings> {
  const res = await axios.get('/api/CompanySettings', getHeaders(token));
  return res.data;
}

export async function updateCompanySettings(
  data: UpdateCompanySettingsRequest,
  token: string | undefined
): Promise<CompanySettings> {
  const res = await axios.put('/api/CompanySettings', data, getHeaders(token));
  return res.data;
}

export async function configureAccountingProvider(
  data: ConfigureAccountingRequest,
  token: string | undefined
) {
  const res = await axios.put('/api/CompanySettings/AccountingProvider', data, getHeaders(token));
  return res.data;
}

export async function removeAccountingProvider(token: string | undefined) {
  const res = await axios.delete('/api/CompanySettings/AccountingProvider', getHeaders(token));
  return res.data;
}
